import React, {useEffect, useState} from "react";
import {Chip, Tooltip} from "@mui/material";
import {Brightness1} from "@mui/icons-material";

import {hexToRgba} from "../../helpers/ColorUtils";
import {CAP_LEVELS} from "../../domain/CapLevels";

export default function CapLevelChip({capLevel}) {

    const [capLevelName, setCapLevelName] = useState('');
    const [capLevelColor, setCapLevelColor] = useState('');

    const capLevelChipStyle = {flexShrink: 0, backgroundColor: "rgba(255, 255, 255, 0.8)", minWidth: "inherit"};

    useEffect(() => {

        if (capLevel) {
            const currentCapLevel = CAP_LEVELS.find(caps => caps.key === capLevel || caps.name === capLevel);
            setCapLevelName(currentCapLevel?.name);
            setCapLevelColor(currentCapLevel?.color);
        }

    }, [capLevel]);

    return <Tooltip title={capLevelName}>
        <Chip size="medium" icon={<Brightness1 style={{color: `${hexToRgba(capLevelColor, 1)}`}}/>} sx={capLevelChipStyle}/>
    </Tooltip>;
}
